import { createAction, handleActions } from "redux-actions";

export const SET_INITIAL_AUTH_CHECK_PENDING =
  "app/initialAuthCheck/SET_INITIAL_AUTH_CHECK_PENDING";

export const setInitialAuthCheckPending = createAction(
  SET_INITIAL_AUTH_CHECK_PENDING,
  (pending: boolean) => ({ pending })
);

const initialState = {
  // Defaults to pending until RootComponent determines the initial auth state.
  pending: true
};

export default handleActions(
  {
    [SET_INITIAL_AUTH_CHECK_PENDING]: (state, { payload }) => ({
      pending: payload.pending
    })
  },
  initialState
);
